import {Component, h} from "preact";


/**
 * @typedef {{
 *      contract: Membership.Contract,
 *      finalization: {
 *          isLoading: boolean,
 *          result: ?{status: string},
 *      },
 * }} SuccessStepContent.Props
 *
 * @typedef {{
 * }} SuccessStepContent.State
 */
export class SuccessStepContent extends Component
{
	/**
	 * @param {SuccessStepContent.Props} props
	 * @param {SuccessStepContent.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		let content = [];

		if (props.finalization.isLoading)
		{
			content.push(<p>Ihre Daten werden gespeichert, bitte einen Moment Geduld...</p>);
		}
		else if ("ok" === props.finalization.result)
		{
			content.push(<p>Ihre Anmeldung wurde erfolgreich gespeichert.</p>);
			content.push(<p>Sie erhalten in Kürze eine Email, bitte den Link mit einem Klick bestätigen zur Aktivierung ihrer Mitgliedschaft.</p>);

			if (props.contract.client.personalization.configuratorRegards !== null)
			{
				// eslint-disable-next-line react/no-danger
				content.push(<p dangerouslySetInnerHTML={{__html: props.contract.client.personalization.configuratorRegards}} />);
			}
			else
			{
				content.push(<p>Vielen Dank für Ihre Anmeldung!</p>);
			}
		}
		else
		{
			content.push(<p class="_membership-success-store-failure">Die Anfrage, Ihre Daten zu speichern ist fehlgeschlagen. Bitte versuchen Sie die Anmeldung erneut, indem Sie die Seite neuladen. Falls die Anmeldung immer noch nicht klappt, wenden Sie sich bitte direkt an uns.</p>);
			content.push(<p><a href={document.location}>Erneut versuchen</a></p>);
		}

		return (
			<div class="_membership-success">
				<div class="_membership-headline">{`Herzlich Willkommen bei ${props.contract.client.name}`}</div>
				{content}
			</div>
		);
	}
}
